export default __webpack_public_path__ + "static/media/instagram.942beb27.svg";